<template>
  <b-overlay :show="showoverlay" rounded="sm">
    <div class="users-style">

      <div class="row no-gutters py-2 mb-3">
        <div class="col-md-10 col-sm-12">
          <h4 class="atlhr-dashboard-title mt-10">
            Activity Log <span class="black-title"></span>
            <span>
              <a v-bind:href="$api_url">Dashboard</a>
              / Activity Log
            </span>
          </h4>
        </div>
      </div>

      <div class="reports-tab-nav">
        <div class="row no-gutters py-2 mb-3">
          <div class="col-sm-6 pl-0">
            <div class="company-form-box-title custom-search">
              <b-input-group class="mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input type="search" placeholder="Search Log" v-model="search"
                  @input="resetPagination()"></b-form-input>
              </b-input-group>
            </div>
          </div>
          <div class="col-sm-6 cursor-pointer text-right company-form-box-title pr-0">
            <b-form-select v-model="month_selected" :options="month_lists" class="w-25"
              @change="getlogs()"></b-form-select>
            <b-form-select v-model="year_selected" :options="year_lists" class="w-25"
              @change="getlogs()"></b-form-select>
          </div>
        </div>
        <div class="row justify-content-center no-margin">
          <div class="employee-table-wrapper table-sticky-height">
            <table
              class="employee-list-table table-overflow table-sticky ess-custom-table document-table tax-documents table-list fund_list_table"
              style="table-layout: fixed;">

              <thead>
                <tr class="table-head hover-bg">
                  <td>Module</td>
                  <td>Activity Type</td>
                  <td>Activity By</td>
                  <td class="med-width">Details</td>
                  <td>IP Address</td>
                  <!-- alpha fix- added width 100px  -->
                  <td class="sm-width" style="width: 100px !important;">Location</td>
                  <td class="lg-width">Browser Details</td>
                  <td>Activity at</td>
                  <!--<td style="text-align: center;">Delete</td>-->
                </tr>
              </thead>
              <tbody>

                <template v-if="paginatedData.length">
                  <tr class="table-row hover-bg" v-for="(log, index) in paginatedData" :key="log.id">
                    <td>{{ log.activity_module }}</td>
                    <td>{{ log.activity_type }}</td>
                    <td>{{ log.activity_user }}</td>
                    <td>{{ log.activity_description }}</td>
                    <td>{{ log.activity_ip_address }}</td>
                    <td>
                      <div class="activity-loc" @click="locationInfo(log.activity_ip_address)">
                        <b-icon icon="geo-alt"></b-icon>
                      </div>
                    </td>
                    <td>{{ log.activity_browser_details }}</td>
                    <td>{{ log.activity_created }}</td>
                  </tr>




                </template>


              </tbody>
            </table>
          </div>

        </div>
        <div v-if="paginatedData.length == 0" class="px-3 py-2 no-result-cell">{{ blankmsg }}</div>

        <template v-if="paginatedData.length > 0">


          <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
            <div class="col-md-12 p-0 no-margin" v-if="paginatedData.length > 0">
              <ul class="pagination b-pagination float-left mb-0 mt-1">
                <li class="page-item disabled m-2">View</li>
                <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options"
                    @change="setFirstPage()"></b-form-select></li>
                <li class="page-item disabled m-2">per page. Total {{ people }} records found.</li>
              </ul>
              <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number
                last-number></b-pagination-nav>
            </div>
          </div>
        </template>
      </div>
    </div>

    <b-modal id="bv-modal-location" hide-footer>
      <template #modal-title>
        Location
      </template>
      <div class="d-block text-center">
        <h3><span v-html="location_info"></span></h3>
      </div>
      <b-button class="mt-3" block @click="$bvModal.hide('bv-modal-location')">Close</b-button>
    </b-modal>


  </b-overlay>
</template>
<script>
export default {
  mounted() {
  },
  data() {
    return {
      logs: [],
      length: 10,
      pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },
      search: '',
      search_by_id: { payrun_id: '', payrun_id_form: '' },
      per_page: 10,
      sortOrders: {},
      showoverlay: false,
      log_not_available: 'Loading please wait....',
      year_lists: [],
      year_selected: null,
      month_lists: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      month_selected: null,
      location_info: '',

      // Mustafijur: 05-05-2026
      length_options: [],
      people: 0,
      length: 20,
      temp_length: 20,
    }
  },
  methods: {
    setPagination: function (pageflg) {
      if (pageflg)
        this.pagination.currentPage = this.pagination.nextPage;
      else
        this.pagination.currentPage = this.pagination.prevPage;

      this.getlogs();
    },

    filterdatelist() {
      this.year_lists = [];
      var date = new Date();
      var year = date.getFullYear();
      this.year_selected = year;
      //alert(date.getMonth());
      this.month_selected = this.month_lists[date.getMonth()];
      for (var i = year - 2; i <= year; i++) {
        this.year_lists.push(i);
      }

    },

    locationInfo: function (ip_address) {

      if (ip_address) {
        this.location_info = 'Loading....';
        this.$bvModal.show('bv-modal-location');
        let location_text = '';
        axios.get(this.$api_url + '/log/location-info', {
          params: {
            ip: ip_address,
          }
        }).then(function (response) {
          if (response.data.country || response.data.city || response.data.zipcode) {
            location_text = "Country: ";
            location_text += response.data.country ? response.data.country : 'N/A';
            location_text += "<br/>City: ";
            location_text += response.data.city ? response.data.city : 'N/A';

            location_text += "<br/>ZIP Code: ";
            location_text += response.data.zipcode ? response.data.zipcode : 'N/A';
            this.location_info = location_text;

          } else {
            this.location_info = 'Sorry location info not available!';
          }
        }.bind(this));
      }
    },

    getlogs: function () {

      this.showoverlay = true;
      this.log_not_available = 'Loading please wait....';

      axios.get(this.$api_url + '/alllogs', {
        params: {
          year: this.year_selected,
          month: this.month_selected,
        }
      }).then(function (response) {
        this.logs = response.data;
        this.pagination.from = response.data.from;
        this.pagination.to = response.data.to;
        this.pagination.total = response.data.total;
        this.people = this.logs.length;

        this.length_options = [{ value: 10, text: "10" }, { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
        { value: 200, text: "200" },
        { value: 500, text: "500" },
        { value: this.logs.length, text: "All" }
        ];

        this.showoverlay = false;
        if (this.logs && this.logs.length > 0)
          this.log_not_available = '';
        else
          this.log_not_available = 'Log data not available...';

        if (this.pagination.to == this.pagination.total) {

          this.pagination.nextbuttonstatus = 'disabled';

        }
        else {
          this.pagination.nextbuttonstatus = '';
        }

        if (this.pagination.from == 1) {
          this.pagination.prebuttonstatus = 'disabled';
        }
        else {
          this.pagination.prebuttonstatus = '';
        }



        if (this.pagination.currentPage < response.data.last_page)
          this.pagination.nextPage = this.pagination.currentPage + 1;

        if (this.pagination.currentPage == 1)
          this.pagination.prevPage = 1;
        else
          this.pagination.prevPage = this.pagination.currentPage - 1;
      }.bind(this));
    },

    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },


    onImageChange(e) {
      //console.log(e.target.files[0]);
      this.image = e.target.files[0];
    },

    ///////////////////////////////////////





  },
  created: function () {
    this.filterdatelist();
    this.getlogs();

  },
  computed:
  {
    filteredData() {
      let filtered_list = this.logs;
      if (this.search) {
        filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

        if (filtered_list.length == 0)
          this.blankmsg = "Nothing found.";
      }

      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey) {
        filtered_list = filtered_list.slice().sort((a, b) => {
          let index = this.getIndex(this.columns, 'name', sortKey);
          a = String(a[sortKey]).toLowerCase();
          b = String(b[sortKey]).toLowerCase();
          if (this.columns[index].type && this.columns[index].type === 'date') {
            return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
          }
          else if (this.columns[index].type && this.columns[index].type === 'number') {
            return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
          }
          else {
            return (a === b ? 0 : a > b ? 1 : -1) * order;
          }
        }
        );
      }

      return filtered_list;
    },
    paginatedData() {
      return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
    },


  }
}
</script>
<style>
button.disabled {
  cursor: default;
}

.tb-border {
  border: 1px solid #808080;
  border-radius: 0.25rem !important;
  border-collapse: separate;
}

.tb-border td {
  padding: 2px !important;
}

.year-wrapper {
  margin-right: 10px !important;
  max-width: 18%;
}
</style>
